<p>
  slats-page works!
</p>
